import classNames from 'classnames'
import React from 'react'

import Link from '@/components/link/link'

import * as styles from './button.module.scss'
import DownloadIcon from './icons/download.svg'
import LinkedinIcon from './icons/linkedin.svg'

export type IconType = 'download' | 'linkedin'

export type ButtonProps = {
  to: string
  title: string | undefined | null
  color?: 'primary' | 'secondary' | 'tertiary' | 'custom'
  openNeWindow?: boolean
  isBgDark?: boolean
  className?: string
  icon?: IconType
  iconPosition?: 'left' | 'right'
}

const getIconComponent = (iconType?: IconType) => {
  if (!iconType) return null

  switch (iconType) {
    case 'download':
      return <img src={DownloadIcon} alt={iconType} />
    case 'linkedin':
      return <img src={LinkedinIcon} alt={iconType} />
    default:
      return null
  }
}

const Button: React.FC<ButtonProps> = ({
  to,
  title,
  color = 'primary',
  openNeWindow = false,
  isBgDark = false,
  className = '',
  icon,
  iconPosition = 'right'
}) => {
  const IconComponent = getIconComponent(icon)

  return (
    <Link
      className={classNames(
        styles.button,
        styles[color],
        isBgDark ? styles.dark : '',
        icon ? [styles.icon, styles[iconPosition]] : '',
        className
      )}
      to={to}
      openInNewWindow={openNeWindow}
    >
      {icon && iconPosition === 'left' && IconComponent}
      {title}
      {icon && iconPosition === 'right' && IconComponent}
    </Link>
  )
}

export default Button
